import React, { useEffect, useState } from 'react';
import Mammoth from 'mammoth';
/**
 *
 * NOTE: we are going to convert to HTML because there is no risk
 * that the user can upload a file which contains malicious scripts
 * (such as XSS attacks).
 *
 * We can further mitigate the security risks sanitizing the
 * html before rendering with DOMPurify.
 *
 * @param document the documen to render
 * @returns
 */
export const DocxPreviewer = ({ document }) => {
    const [text, setText] = useState('');
    useEffect(() => {
        const fetchAndRenderDocx = async () => {
            try {
                const response = await fetch(document.url);
                if (!response.ok)
                    throw new Error('Failed to fetch document');
                const arrayBuffer = await response.arrayBuffer();
                // Extract text using Mammoth
                const { value: extractedText } = await Mammoth.convertToHtml({ arrayBuffer });
                setText(extractedText || 'No text found in document.');
            }
            catch (error) {
                console.error('Error loading document:', error);
                setText('Error loading document.');
            }
        };
        fetchAndRenderDocx();
    }, [document]);
    return (React.createElement("div", { style: { padding: 20, maxWidth: '100%', margin: 'auto' } },
        React.createElement("div", { dangerouslySetInnerHTML: { __html: text } })));
};
export default DocxPreviewer;
